import { useEffect, useState } from 'react';

export interface CurrentMinute {
  now: Date;
}

export function useCurrentMinute(): CurrentMinute {
  const [now, setNow] = useState<Date>(() => new Date());

  useEffect(() => {
    const tick = () => setNow(new Date());
    let intervalId: ReturnType<typeof setInterval> | undefined;

    // Align the first tick to the next minute boundary. A plain 60s interval
    // fires at an arbitrary offset from mount, so a NOW card whose start time
    // is HH:MM:00 could appear up to ~60s late (the reported 20-40s lag).
    const msToNextMinute = 60_000 - (Date.now() % 60_000);
    const timeoutId = setTimeout(() => {
      tick();
      intervalId = setInterval(tick, 60_000);
    }, msToNextMinute);

    const onVisibility = () => {
      if (!document.hidden) tick();
    };
    document.addEventListener('visibilitychange', onVisibility);
    return () => {
      clearTimeout(timeoutId);
      if (intervalId) clearInterval(intervalId);
      document.removeEventListener('visibilitychange', onVisibility);
    };
  }, []);

  return { now };
}
